/**
 * PrintableAssessmentReportV2 — V2 report component owned by active code.
 *
 * This is the canonical print/PDF report component. It wraps the underlying
 * PrintableReport and defaults to the V2_DECISION layout, which includes a
 * "Report layout: V2" footer stamp on every generated PDF.
 *
 * Import this component (not PrintableReport from hub directly) so that PDF
 * rendering is always owned by active components/ code and Copilot never
 * needs to touch the deprecated story shell to render reports.
 *
 * Usage:
 *   import { PrintableAssessmentReportV2 } from '../report/PrintableAssessmentReportV2';
 *   <PrintableAssessmentReportV2 optionA={...} optionB={...} ... />
 */
import { PrintableReport, type PrintableReportProps } from '../hub/PrintableReport';

export type PrintableAssessmentReportV2Props = PrintableReportProps;

/**
 * V2 assessment report. Always renders using V2_DECISION layout unless
 * an explicit override is supplied.
 */
export function PrintableAssessmentReportV2(props: PrintableAssessmentReportV2Props) {
  return <PrintableReport {...props} reportLayout={props.reportLayout ?? 'V2_DECISION'} />;
}
